<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <h1 class="navbar-brand">
      <span class="d-none d-lg-inline">Sistema de Descuentos</span>
      <span v-if="VistaActual" class="d-lg-none">{{ VistaActual.titulo }}</span>
      <span v-if="VistaActual" class="d-lg-none titulo-sistema-descuentos"
        >Sistema de Descuentos</span
      >
    </h1>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="collapse navbar-collapse"
      id="navbarSupportedContent"
      data-bs-toggle="collapse"
      data-bs-target=".navbar-collapse.show"
    >
      <ul class="navbar-nav mr-auto">
        <li
          v-for="(vista, index) in vistas"
          v-bind:key="index"
          class="nav-item"
          v-bind:class="{ active: vista == VistaActual }"
        >
          <a class="nav-link cursor-pointer" @click="cambiarVista(vista)">
            <font-awesome-icon :icon="vista.icono" />
            <span class="ml-2">{{ vista.titulo }}</span>
          </a>
        </li>
      </ul>
      <button @click="clickLogOut()" type="button" class="btn btn-link">
        Salir
      </button>
    </div>
  </nav>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import router from "../../routes/router";

const EVENT_LOG_OUT = "on-log-out";
const EVENTO_VISTA_CAMBIADA = "evento-vista-cambiada";

export default {
  props: {
    raiz: {
      type: String,
      default: "",
    },
    vistas: Array,
  },
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      vistaActual: null,
    };
  },
  computed: {
    VistaActual() {
      return this.vistaActual;
    },
  },
  watch: {
    // Se recalcula la vista cuando cambia la url
    $route() {
      this.calcularVistaActual();
    },
  },
  methods: {
    calcularVistaActual() {
      const nombreVistaActual = this.$route.name;

      this.vistaActual = this.vistas.find((v) => v.name == nombreVistaActual);
    },
    cambiarVista(nuevaVista) {
      router.push({ name: nuevaVista.name });

      this.$emit(EVENTO_VISTA_CAMBIADA, nuevaVista);
    },
    clickLogOut() {
      this.$emit(EVENT_LOG_OUT);
    },
  },
  mounted() {
    this.calcularVistaActual();
  },
};
</script>
<style lang="scss">
.navbar-nav {
  flex-wrap: wrap;
}

@media (max-width: 992px) {
  .navbar-brand {
    max-height: 48px;
    display: flex;
    flex-direction: column;
    .titulo-sistema-descuentos {
      font-size: 12px;
    }
  }
}

@media (min-width: 991px) and (max-width: 1084px) {
  .navbar {
    flex-wrap: wrap !important;
  }

  .nav-item a span {
    font-size: 0.8rem;
  }

  .nav-link {
    padding-right: 0.3rem;
    padding-left: 0.3rem;
  }
}

@media (min-width: 1085px) and (max-width: 1400px) {
  .navbar-nav {
    flex-wrap: wrap;
  }
  .navbar {
    flex-wrap: wrap !important;
  }
  .nav-item a span {
    font-size: 0.9rem;
  }

  .nav-link {
    padding-right: 0.6rem;
    padding-left: 0.6rem;
  }
}
</style>
